export const COLOR_yellow = "#FCA311";
export const COLOR_blue = "#14213D";
export const COLOR_grey = "#E5E5E5";
export const COLOR_slate = "#DCCFBC";
export const COLOR_slate_semitransparent = "#DCCFBC33"
export const COLOR_white = '#FEFEFE';